import { Flex, Header1, TertiarySmall, Ingress } from "@base-ui";
import { HeaderBlock, SoughtValue } from "./headerblock.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Header(props) {
  var ingress = props.ingress,
    soughtValue = props.soughtValue,
    title = props.title;
  var ingressMarkup = ingress === null || ingress === void 0 ? void 0 : ingress.split("\n").map(function (x, idx) {
    return /*#__PURE__*/_jsx(Ingress, {
      inverted: true,
      maxWidth: "800px",
      children: x
    }, idx);
  });
  var soughtValueMarkup = ["Högt", "Lågt"].includes(soughtValue) && /*#__PURE__*/_jsxs(Flex.Column, {
    width: "80px",
    ml: "40px",
    children: [/*#__PURE__*/_jsx(TertiarySmall, {
      as: "p",
      inverted: true,
      m: "0 0 2px",
      children: "\xD6nskat v\xE4rde:"
    }), /*#__PURE__*/_jsx(SoughtValue, {
      soughtValue: soughtValue,
      children: soughtValue
    })]
  });
  return /*#__PURE__*/_jsx(HeaderBlock, {
    children: /*#__PURE__*/_jsxs(Flex.Column, {
      children: [/*#__PURE__*/_jsxs(Flex.Row, {
        justify: "space-between",
        children: [/*#__PURE__*/_jsx(Header1, {
          inverted: true,
          mb: "10px",
          width: "calc(100% - 120px)",
          children: title
        }), soughtValueMarkup]
      }), ingressMarkup]
    })
  });
}